import React from "react";
import { TrapSite } from "../../types/api/models/trapSite";
import { Typography } from "antd";
import { MapPinIcon } from "@heroicons/react/24/outline";
import MapComponent from "../Map";

interface TrapsiteContainerProps {
  trapSite?: Partial<TrapSite>;
}

const { Text } = Typography;

const TrapsiteContainer: React.FC<TrapsiteContainerProps> = ({ trapSite }) => (
  <div className="max-w-108 min-w-108 min-h-108 flex flex-col h-full">
    <div className="bg-gray-100 rounded-lg flex-1 min-w-108 min-h-108 w-full relative border border-gray-300 overflow-hidden [&_.map-container-big]:!p-0 [&_.map-container-big]:absolute [&_.map-container-big]:inset-0 [&_.leaflet-container]:!border-0 [&_.leaflet-container]:!rounded-none">
      <MapComponent />
    </div>

    <div className="flex items-start gap-4 mt-4 text-[#0C4A6E]">
      <MapPinIcon className="w-8 h-8 flex-shrink-0" strokeWidth={2} />
      <div className="flex flex-col gap-1">
        <div className="text-xl font-bold">
          {trapSite?.display_name
            ? trapSite.display_name
            : "Unassigned Location"}
        </div>
        {trapSite && (
          <>
            <Text>
              {trapSite.address}
              <br />
              {trapSite.gps?.lat?.toFixed(4)}, {trapSite.gps?.lon?.toFixed(4)}
            </Text>
          </>
        )}
      </div>
    </div>
  </div>
);

export default TrapsiteContainer;
